/* projects/speaker-platform/src/app/pages/admin/speaker-create/speaker-create.component.scss */
.speakercreate__photo {
  width: 145px;
  height: 145px;
  margin-bottom: 16px;
  background-color: #ADADAD;
  text-align: center;
  border-radius: 50%;
}
.speakercreate__photo img {
  border-radius: 50%;
}
.speakercreate__password {
  flex: 1 0 auto;
  margin-right: 16px;
}
.speakercreate__recorddays {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 10px;
}
.speakercreate__recorddays__day {
  text-align: center;
}
/*# sourceMappingURL=speaker-create.component-JYIGO3M6.css.map */
